import { setFollowStatusFn } from "@/actions/community/handler";
import { Button } from "@/components/ui/button";
import { useMutation } from "@tanstack/react-query";
import { Bell, BellOff } from "lucide-react";
import { useState } from "react";
import { toast } from "sonner";

export function LibraryFollowButton({
  pathId,
  initialFollowing,
  authenticated,
}: {
  pathId: string;
  initialFollowing: boolean;
  authenticated: boolean;
}) {
  const [following, setFollowing] = useState(initialFollowing);
  const mutation = useMutation({
    mutationFn: (next: boolean) =>
      setFollowStatusFn({
        data: {
          resourceType: "library_path",
          resourceId: pathId,
          following: next,
        },
      }),
    onSuccess: ({ following: next }) => setFollowing(next),
    onError: () => toast.error("Takip tercihi kaydedilemedi."),
  });

  return (
    <Button
      type="button"
      variant={following ? "outline" : "default"}
      onClick={() => {
        if (!authenticated) {
          toast.info("Öğrenme yolunu takip etmek için giriş yapın.");
          return;
        }
        mutation.mutate(!following);
      }}
      disabled={mutation.isPending}
    >
      {following ? (
        <BellOff className="mr-2 h-4 w-4" />
      ) : (
        <Bell className="mr-2 h-4 w-4" />
      )}
      {following ? "Takibi bırak" : "Yolu takip et"}
    </Button>
  );
}
